<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  mounted () {
    console.log(this.$route)
  },
  created () {
    let params = {
      dto: {
      }
    }
    console.log(this.currentUser)
    if (!this.currentUser.type) {
      this.$store.dispatch('applyCustomer', params).then((data) => {
        console.log(data.dtoList[0])

        if (this.$route.path === '/') {
          if (this.currentUser.type === 1) { // 1.'个人用户', 2.'代理机构', 3.'会员用户', 4.'管理员'
            this.$router.push({name: 'management'})
          }
          if (this.currentUser.type === 2) {
            this.$router.push({name: 'company-1'})
          }
          if (this.currentUser.type === 3) {
            this.$router.push({name: 'company-1'})
          }
          if (this.currentUser.type === 4) {
            this.$router.push({name: 'audit-article'})
          }
        }
      })
    }
  }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
body{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue